<div class="page-content-wrapper">
  <div class="card rounded-3 border-1 shadow">
     <div class="card-header bg-white border-0">
      <p class="text-s fw-bold">Instant Verify Request</p>
    </div>
    <div class="card-body">
      <CustomTable
        :columns="columns"
        :fetchData="getClients"
        :key="getClients"
        :hasActions="true"
        tableKey="instant_verify_requests"
      >
        <template v-slot:cell-name_email="{ row }">
          {{ row.first_name || row.full_name }} {{ row.last_name || '' }}
          <p class="text-xxs fw-bold">{{ row.email }}</p>
        </template>
        <template v-slot:cell-date_joined="{ row }">
          {{ formatDate(row.date_joined)}}
        </template>
        <template v-slot:actions="{ row }">
          <button class="btn bg-green btn-sm text-xxs fw-bold rounded-3 me-2 shadow" @click="view_client_logs(row.id)">View logs</button>
          <button class="btn bg-green btn-sm text-xxs fw-bold rounded-3 me-2 shadow" @click="view_client_services(row.id)">View Services</button>
        </template>
      </CustomTable>
    </div>
  </div>
</div>